import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AssessmentDetails from '../components/AssessmentDetails';
import { assessments } from '../data/assessments';

export default function LearnMorePage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            
              <h1 className="text-3xl font-bold mb-4 relative font-montserrat text-gray-700">
                Assessment Details
                {/* Decorative underline */}
                <div className="absolute -bottom-2 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-brand-primary to-transparent opacity-75" />
              </h1>
            
          </div>
          <AssessmentDetails assessments={assessments} />
        </div>
      </div>
      <Footer />
    </div>
  );
}